import type { ReactNode } from "react";
import styles from "./Badge.module.css";

/** Tono semántico del badge. Soft por defecto (fondo tenue + texto de color);
 *  `solid` para énfasis de alerta (p. ej. QA "SIN VALIDEZ CLÍNICA"). */
export type BadgeTone = "neutral" | "teal" | "amber" | "green" | "red" | "purple";

/** Badge/chip unificado para estados, QA, perfil y flags del panel del terapeuta.
 *  Reemplaza las implementaciones ad hoc dispersas por pantalla. */
export function Badge({
  tone = "neutral",
  solid = false,
  children,
  className,
  title,
}: {
  tone?: BadgeTone;
  solid?: boolean;
  children: ReactNode;
  className?: string | undefined;
  title?: string | undefined;
}) {
  const cls = [styles.badge, styles[tone], solid ? styles.solid : "", className ?? ""]
    .filter(Boolean)
    .join(" ");
  return (
    <span className={cls} title={title}>
      {children}
    </span>
  );
}
